import Button from "components/base/Button";
import axiosInstance from "helpers/api";
import { Form } from "react-bootstrap";
import { useForm, SubmitHandler } from "react-hook-form";
import toast from "react-hot-toast";
import { useNavigate, useSearchParams } from "react-router-dom";

type Inputs = {
  password: string;
  confirm_password: string;
};

const ResetPasswordForm = () => {
  const {
    register,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
  } = useForm<Inputs>();

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const passwordValue = watch("password");

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    try {
      const response = await axiosInstance.post(
        `/auth/reset-password?token=${token}`,
        {
          password: data.password,
          confirm_password: data.confirm_password,
        }
      );
      toast.success(response.data.message);
      navigate("/sign-in");
    } catch (error: any) {
      toast.error(error.response.data.message);
    }
    reset();
  };
  
  return (
    <div className="text-center mb-6">
      <h4 className="text-body-highlight">Reset new password</h4>
      <p className="text-body-tertiary">Type your new password</p>
      <Form className="mt-5" onSubmit={handleSubmit(onSubmit)}>
        <Form.Control
          className="mb-2"
          id="password"
          type="password"
          placeholder="Type new password"
          {...register("password", { required: true, maxLength: 40 })}
        />
        <Form.Control
          className="mb-2"
          id="confirmPassword"
          type="password"
          placeholder="Confirm new password"
          {...register("confirm_password", {
            required: true,
            validate: (value) =>
              value === passwordValue || "Passwords do not match",
          })}
        />
        {errors.confirm_password && (
          <p role="alert" className="text-danger fs-9 pt-1">
            {errors.confirm_password.message}
          </p>
        )}
        <Button variant="primary" type="submit" className="w-100">
          Set Password
        </Button>
      </Form>
    </div>
  );
};

export default ResetPasswordForm;
